import { Button, tokens } from "@manifesthhqinc/ui-library";
import { BodyLargeRegular, BodyMediumRegular, HeadlineMedium, LabelLarge, TitleMedium } from "../../../components/font";

import TransitionWrapper from "../../../components/transition-wrapper/TransitionWrapper";
import Container from "../../../layout/container";
import ScrollableContainer from "../../../layout/scrollable-container";
import { UseExploreIRAOptionsType } from "../useExploreIRAOptions";
import HenryAvator from "../../../components/henry/HenryAvator";
import {
  DisclimaerText,
  FeatureChip,
  HenrySuggestionChip,
  HenrySuggestionCTADiv,
  HenrySuggestionFeatureDiv,
  HenrySuggestionIRATile,
  HenrySuggestionIRATileLogoDiv,
  HenrySuggestionIRATileLogoDivider,
  HereIsWhyContent,
  HereIsWhyHeader,
  HereIsWhyHeaderAccordion,
  HereIsWhyItem,
  IRAOptionFeatureDiv,
  SeeMoreOptionsButton,
  SeeMoreOptionsContent,
} from "./styles";
import { Chevron } from "../../../components/icons";
import { useState } from "react";
import { CHEVRON_ORIENTATION_DOWN, CHEVRON_ORIENTATION_UP } from "../../../components/icons/constants";
import Spacing from "../../../layout/spacing";
import HeadingContainer from "../../../layout/heading-container";

const ExploreIRAOptions = (props: UseExploreIRAOptionsType) => {
  const { iraRecommendationContent, onClickRestart, onClickOpenAccount, onClickLearnMore } = props;
  const [showMoreOptions, setShowMoreOptions] = useState<boolean>(false);
  const [isExpanded, setIsExpanded] = useState<boolean>(false);
  return (
    <TransitionWrapper>
      <ScrollableContainer name="explore-ira-options-overview">
        <Container>
          <HeadingContainer paneVariant="list" withProgressBar>
            <HeadlineMedium $textAlign="center">Your destination options</HeadlineMedium>
            <BodyLargeRegular $textAlign="center">
              Manifest uses your answers to suggest the best option
            </BodyLargeRegular>
          </HeadingContainer>
          <IRAOptionFeatureDiv>
            <HenrySuggestionIRATile $isFeatured={true}>
              <HenrySuggestionChip>
                <HenryAvator height={30} width={30} />
                Henry’s suggestion
              </HenrySuggestionChip>
              <HenrySuggestionIRATileLogoDiv>
                <img src={iraRecommendationContent?.FIRST.logo} alt={iraRecommendationContent?.FIRST.providerName} />
              </HenrySuggestionIRATileLogoDiv>
              <HenrySuggestionIRATileLogoDivider />
              <HenrySuggestionFeatureDiv>
                <FeatureChip>
                  <LabelLarge $color={tokens.color.brand[600]}>Easy Account Opening*</LabelLarge>
                </FeatureChip>
                <FeatureChip>
                  <LabelLarge $color={tokens.color.brand[600]}>Match Score: 98%</LabelLarge>
                </FeatureChip>
              </HenrySuggestionFeatureDiv>
              <BodyMediumRegular $color={tokens.color.text.secondary}>
                {iraRecommendationContent?.FIRST.descriptionMain}
              </BodyMediumRegular>
              <HereIsWhyHeaderAccordion>
                <HereIsWhyHeader onClick={() => setIsExpanded(!isExpanded)}>
                  Here is why
                  <Chevron
                    width={12}
                    height={7}
                    color={tokens.color.neutral[600]}
                    orientation={isExpanded ? CHEVRON_ORIENTATION_UP : CHEVRON_ORIENTATION_DOWN}
                  />
                </HereIsWhyHeader>
                <HereIsWhyContent $isExpanded={isExpanded}>
                  {iraRecommendationContent?.FIRST.hereIsWhy?.map((el) => (
                    <HereIsWhyItem key={el.text}>
                      {el.icon}
                      <BodyMediumRegular>{el.text}</BodyMediumRegular>
                    </HereIsWhyItem>
                  ))}
                </HereIsWhyContent>
              </HereIsWhyHeaderAccordion>
              <HenrySuggestionCTADiv>
                <Button
                  name={`openAccount-${iraRecommendationContent?.FIRST.providerName}`}
                  onClick={() => onClickOpenAccount(iraRecommendationContent?.FIRST.providerName || "")}
                >
                  Open account
                </Button>
                <Button
                  variant="text"
                  className="text-cta"
                  onClick={() => onClickLearnMore(iraRecommendationContent?.FIRST.providerName || "")}
                  name={`learnMore-${iraRecommendationContent?.FIRST.providerName}`}
                >
                  Learn more
                </Button>
              </HenrySuggestionCTADiv>
            </HenrySuggestionIRATile>
            <HenrySuggestionIRATile $isFeatured={false}>
              <TitleMedium>{iraRecommendationContent?.SECOND.providerName}</TitleMedium>

              <HenrySuggestionFeatureDiv>
                <FeatureChip>
                  <LabelLarge $color={tokens.color.brand[600]}>Easy Account Opening*</LabelLarge>
                </FeatureChip>
              </HenrySuggestionFeatureDiv>
              <BodyMediumRegular $color={tokens.color.text.secondary}>
                {iraRecommendationContent?.SECOND.descriptionMain}
              </BodyMediumRegular>
              <HenrySuggestionCTADiv>
                <Button
                  name={`openAccount-${iraRecommendationContent?.SECOND.providerName}`}
                  variant="secondary"
                  onClick={() => onClickOpenAccount(iraRecommendationContent?.SECOND.providerName || "")}
                >
                  Open account
                </Button>
                <Button
                  variant="text"
                  className="text-cta"
                  onClick={() => onClickLearnMore(iraRecommendationContent?.SECOND.providerName || "")}
                  name={`learnMore-${iraRecommendationContent?.SECOND.providerName}`}
                >
                  Learn more
                </Button>
              </HenrySuggestionCTADiv>
            </HenrySuggestionIRATile>
          </IRAOptionFeatureDiv>
          <SeeMoreOptionsButton onClick={() => setShowMoreOptions(!showMoreOptions)}>
            See more options{" "}
            <Chevron
              width={16}
              height={10}
              color={tokens.color.neutral[600]}
              orientation={showMoreOptions ? CHEVRON_ORIENTATION_UP : CHEVRON_ORIENTATION_DOWN}
            />
          </SeeMoreOptionsButton>
          <SeeMoreOptionsContent $show={showMoreOptions}>
            <HenrySuggestionIRATile $isFeatured={false}>
              <TitleMedium>{iraRecommendationContent?.THIRD.providerName}</TitleMedium>
              <BodyMediumRegular $color={tokens.color.text.secondary}>
                {iraRecommendationContent?.THIRD.descriptionMain}
              </BodyMediumRegular>
              <Button
                name="openAccount"
                variant="secondary"
                onClick={() => onClickOpenAccount(iraRecommendationContent?.THIRD.providerName || "")}
              >
                Select destination
              </Button>
            </HenrySuggestionIRATile>
            <HenrySuggestionIRATile $isFeatured={false}>
              <TitleMedium>{iraRecommendationContent?.FOURTH.providerName}</TitleMedium>
              <BodyMediumRegular $color={tokens.color.text.secondary}>
                {iraRecommendationContent?.FOURTH.descriptionMain}
              </BodyMediumRegular>

              <Button
                name="openAccount"
                variant="secondary"
                onClick={() => onClickOpenAccount(iraRecommendationContent?.FOURTH.providerName || "")}
              >
                Select destination
              </Button>
            </HenrySuggestionIRATile>
            <Spacing vertical="23" />
            <Button variant="text" onClick={onClickRestart}>
              Restart questions
            </Button>
          </SeeMoreOptionsContent>
          <DisclimaerText>
            *We partner with some providers to make opening your account easier, and may receive compensation when you
            choose them.
          </DisclimaerText>
        </Container>
      </ScrollableContainer>
    </TransitionWrapper>
  );
};

export default ExploreIRAOptions;
